export default __webpack_public_path__ + "static/media/sentencing-1.51843a4c.jpg";